import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import PhoneIcon from 'dibs-vg/dist/react/phone';
import { PdpSharedBlurb } from './PdpSharedBlurb/PdpSharedBlurb';
import { supportNumberTitle, supportNumberText } from '../messages/pdpBlurbMessages';

// styles
import styles from './PdpSharedBlurbs.scss';

// helpers
import get from 'lodash.get';

const ITEM_PRICE_TRESHOLD_USD = 2500;

function PdpSharedBlurbSupportNumberComponent({ viewer, user, item, useCallLink }) {
    const isUserTradeOrVip = user && (user.isVerifiedTrade || user.isVip);
    if (!viewer.isEnabled || isUserTradeOrVip) {
        return null;
    }

    const totalAmountInUSD = get(item, 'pricing.totalAmount.convertedAmounts.USD');
    if (totalAmountInUSD <= ITEM_PRICE_TRESHOLD_USD) {
        return null;
    }

    const supportPhoneNumber = get(viewer, 'contactInfo.phoneNumbers.support');
    const callLink = <a href={`tel:${supportPhoneNumber}`}>{supportPhoneNumber}</a>;
    return (
        <PdpSharedBlurb IconComponent={PhoneIcon} dataTn="pdp-blurb-support-number">
            <span className={styles.title}>{supportNumberTitle}</span>{' '}
            {supportNumberText(useCallLink ? callLink : supportPhoneNumber)}
        </PdpSharedBlurb>
    );
}

PdpSharedBlurbSupportNumberComponent.propTypes = {
    viewer: PropTypes.object.isRequired,
    user: PropTypes.object,
    item: PropTypes.object.isRequired,
    useCallLink: PropTypes.bool,
};

export const PdpSharedBlurbSupportNumber = createFragmentContainer(
    PdpSharedBlurbSupportNumberComponent,
    {
        viewer: graphql`
            fragment PdpSharedBlurbSupportNumber_viewer on Viewer {
                isEnabled: isEnabledByLocale(featureName: "PDP_SUPPORT_NUMBER_BLURB")
                contactInfo {
                    phoneNumbers {
                        support(formatType: INTERNATIONAL)
                    }
                }
            }
        `,
        user: graphql`
            fragment PdpSharedBlurbSupportNumber_user on User {
                isVerifiedTrade
                isVip
            }
        `,
        item: graphql`
            fragment PdpSharedBlurbSupportNumber_item on Item {
                pricing {
                    totalAmount {
                        convertedAmounts {
                            USD
                        }
                    }
                }
            }
        `,
    }
);
